import {
  XA_POLL_NEW_INSTALL_SUCCESS,
  XA_NEW_AGENT_HANDLED,
} from '../../actions/xAgent';

export const INITIAL_STATE = {
  lastLoad: new Date(),
  seen: [],
  newAgents: [],
};

export default function xAgentCheckNewAgent(state = INITIAL_STATE, action) {
  switch (action.type) {
    case XA_POLL_NEW_INSTALL_SUCCESS: {
      if (!action.loginUser) {
        return state;
      }
      const loginUserId = action.loginUser.loggedInUserProfile.id;
      const newAgents = action.payload.data.filter(
        agent =>
          new Date(agent.created).getTime() >= state.lastLoad.getTime() &&
          agent.owner.id === loginUserId &&
          state.seen.indexOf(agent.id) === -1,
      );
      // add new agents to seen
      const seen = [...state.seen, ...newAgents.map(e => e.id)];
      return {
        ...state,
        newAgents: [...state.newAgents, ...newAgents],
        seen,
      };
    }
    case XA_NEW_AGENT_HANDLED: {
      return {
        ...state,
        newAgents: [],
      };
    }
    default: {
      return state;
    }
  }
}
